import axios from 'axios';
import {useTranslation} from 'react-i18next';
import {redirect} from 'react-router-dom';
import delay from '@utils/delay';

export default function Callback() {
	const {t} = useTranslation();
	return (
		<div>{t('wait_for_login')}</div>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function callbackLoader(data: loader) {
	const url = new URL(data.request.url);
	const code = url.searchParams.get('code');
	const error = url.searchParams.get('error');
	if (error) {
		// TODO: show snackbar error
		return redirect('/');
	} else {
		const token = localStorage.getItem('rezvan_token');
		if (token) {
			const res = await axios({
				url: `${process.env.REACT_APP_BASE_URL ?? 'http://localhost:5000/api/'}create`,
				method: 'POST',
				data: {
					code,
					token
				}
			});
			if (res.data.success) {
				localStorage.setItem('isLogin', 'true');
				await delay(1000);
				return redirect('/profile');
			}
		} else {
			return redirect('/');
		}
	}
}
